<!-- ── Backdrop (modal mode only) ─────────────────────────────────────────── -->
<div *ngIf="asModal" class="mtr-backdrop" (click)="close()"></div>

<div class="mtr-shell" [class.mtr-modal]="asModal" [class.mtr-page]="!asModal">

  <!-- Header -->
  <div class="mtr-header">
    <span class="mtr-header-icon"><i class="pe-7s-graph1"></i></span>
    <div class="mtr-header-text">
      <span class="mtr-title">Book Exchange History</span>
      <ng-container *ngIf="selectedMember">
        <span class="mtr-subtitle">{{ selectedMember.name }}</span>
        <span class="mtr-member-details">
          <ng-container *ngIf="selectedMember.memberSrNo || selectedMember.memNo">No. {{ selectedMember.memberSrNo || selectedMember.memNo }}</ng-container>
          <ng-container *ngIf="selectedMember.memNo && selectedMember.memberSrNo"> · Mem No. {{ selectedMember.memNo }}</ng-container>
          <ng-container *ngIf="selectedMember.phone"> · {{ selectedMember.phone }}</ng-container>
          <ng-container *ngIf="memberLocation"> · {{ memberLocation }}</ng-container>
        </span>
      </ng-container>
    </div>
    <div class="mtr-header-actions">
      <button *ngIf="view === 'transactions' && !preselectedMember" type="button" class="btn btn-sm btn-outline-secondary"
              (click)="changeSearch()">
        <i class="pe-7s-angle-left me-1"></i> Back
      </button>
      <button *ngIf="asModal" type="button" class="mtr-close-btn" (click)="close()" title="Close">
        <i class="pe-7s-close"></i>
      </button>
    </div>
  </div>

  <!-- ── SEARCH VIEW ──────────────────────────────────────────────────────── -->
  <div class="mtr-body mtr-body--search" *ngIf="view === 'search'">
    <div class="mtr-two-col">

      <!-- Left: search fields -->
      <div class="mtr-search-col">
        <div class="mtr-search-grid">

          <div class="mtr-search-field">
            <label class="form-label fw-semibold mb-1">Member No</label>
            <div class="input-group">
              <span class="input-group-text"><i class="pe-7s-id"></i></span>
              <input type="text" class="form-control" placeholder="e.g. 424"
                     [(ngModel)]="searchNo" (keyup.enter)="searchByField('no')"
                     [disabled]="isLoadingMembers" />
              <button class="btn btn-primary" (click)="searchByField('no')"
                      [disabled]="!searchNo.trim() || isLoadingMembers">
                <i class="pe-7s-search me-1"></i>Search
              </button>
            </div>
          </div>

          <div class="mtr-search-field">
            <label class="form-label fw-semibold mb-1">Membership No</label>
            <div class="input-group">
              <span class="input-group-text"><i class="pe-7s-id"></i></span>
              <input type="text" class="form-control" placeholder="e.g. HD/12"
                     [(ngModel)]="searchMemNo" (keyup.enter)="searchByField('memNo')"
                     [disabled]="isLoadingMembers" />
              <button class="btn btn-primary" (click)="searchByField('memNo')"
                      [disabled]="!searchMemNo.trim() || isLoadingMembers">
                <i class="pe-7s-search me-1"></i>Search
              </button>
            </div>
            <div class="form-text">Full no. (HD/12) or just the number (12).</div>
          </div>

          <div class="mtr-search-field">
            <label class="form-label fw-semibold mb-1">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="pe-7s-user"></i></span>
              <input type="text" class="form-control" placeholder="e.g. Rahul Sharma"
                     [(ngModel)]="searchName" (keyup.enter)="searchByField('name')"
                     [disabled]="isLoadingMembers" />
              <button class="btn btn-primary" (click)="searchByField('name')"
                      [disabled]="searchName.trim().length < 3 || isLoadingMembers">
                <i class="pe-7s-search me-1"></i>Search
              </button>
            </div>
            <div class="form-text">Min 3 characters. Fuzzy / phonetic matching enabled.</div>
          </div>

          <div class="mtr-search-field">
            <label class="form-label fw-semibold mb-1">Mobile No</label>
            <div class="input-group">
              <span class="input-group-text"><i class="pe-7s-phone"></i></span>
              <input type="tel" class="form-control" placeholder="e.g. 9876543210"
                     [(ngModel)]="searchPhone" (keyup.enter)="searchByField('phone')"
                     [disabled]="isLoadingMembers" />
              <button class="btn btn-primary" (click)="searchByField('phone')"
                      [disabled]="!searchPhone.trim() || isLoadingMembers">
                <i class="pe-7s-search me-1"></i>Search
              </button>
            </div>
          </div>

        </div>
      </div><!-- /search col -->

      <!-- Right: results -->
      <div class="mtr-results-col">

        <div class="text-center py-3" *ngIf="isLoadingMembers">
          <span class="spinner-border text-primary spinner-border-sm"></span>
          <p class="mt-2 mb-0 text-muted small">Searching…</p>
        </div>

        <div class="alert alert-danger py-2 px-3 small" *ngIf="searchError && !isLoadingMembers">
          <i class="pe-7s-attention me-1"></i>{{ searchError }}
        </div>

        <div class="mtr-search-hint" *ngIf="!isLoadingMembers && !hasSearched && !searchError">
          <i class="pe-7s-search"></i>
          <p>Search results will appear here.</p>
        </div>

        <div *ngIf="hasSearched && !isLoadingMembers && memberSuggestions.length === 0 && !searchError"
             class="mtr-search-hint">
          <i class="pe-7s-users"></i>
          <p>No members found.</p>
        </div>

        <div *ngIf="hasSearched && memberSuggestions.length" class="mtr-suggestions">
          <div class="mtr-suggestions-header">
            {{ memberSuggestions.length }} result(s) — click a member to view transactions
          </div>
          <div class="mtr-suggestions-list">
            <div class="mtr-suggestion-item" *ngFor="let m of memberSuggestions"
                 (click)="selectMember(m)">
              <div class="mtr-sug-name">{{ m.name }}</div>
              <div class="mtr-sug-meta">
                <span *ngIf="m.memberSrNo || m.memNo">
                  <i class="pe-7s-id"></i> {{ m.memberSrNo || m.memNo }}
                </span>
                <span *ngIf="m.memNo && m.memberSrNo" title="Membership No">
                  <i class="pe-7s-note2"></i> {{ m.memNo }}
                </span>
                <span *ngIf="m.phone">
                  <i class="pe-7s-call"></i> {{ m.phone }}
                </span>
                <span *ngIf="m.area">
                  <i class="pe-7s-map-marker"></i> {{ m.area }}
                </span>
                <span class="badge"
                      [class.bg-success]="(m._memberTypeRaw ?? m.memberType) === 'A'"
                      [class.bg-primary]="(m._memberTypeRaw ?? m.memberType) === 'H'">
                  {{ (m._memberTypeRaw ?? m.memberType) === 'H' ? 'Door Delivery' : 'At Center' }}
                </span>
                <span [class]="memberStatusBadge(m).cls">{{ memberStatusBadge(m).label }}</span>
              </div>
            </div>
          </div>
        </div>

      </div><!-- /results col -->

    </div>
  </div><!-- /search view -->

  <!-- ── TRANSACTIONS VIEW ────────────────────────────────────────────────── -->
  <div class="mtr-body" *ngIf="view === 'transactions'">

    <!-- Closure details (closed members only) -->
    <div *ngIf="isSelectedMemberClosed"
         class="alert alert-danger d-flex align-items-start gap-2 py-2 px-3 mb-3 small">
      <i class="pe-7s-lock mt-1 flex-shrink-0"></i>
      <div>
        <strong>Membership closed</strong>
        <span *ngIf="selectedMember.closedAt || selectedMember.closureDetails?.closedAt">
          on {{ (selectedMember.closedAt || selectedMember.closureDetails?.closedAt) | appDate }}</span>
        <div>Reason: <strong>{{ selectedMember.closureDetails?.closureReason || 'Not recorded' }}</strong></div>
        <div *ngIf="selectedMember.closureDetails?.refundRemarks">Remarks: {{ selectedMember.closureDetails.refundRemarks }}</div>
      </div>
    </div>

    <!-- Loading -->
    <div class="text-center py-4" *ngIf="isLoadingTxns">
      <div class="spinner-border text-primary spinner-border-sm"></div>
      <p class="text-muted small mt-2">Loading transactions…</p>
    </div>

    <!-- Error -->
    <div class="alert alert-danger py-2 px-3 small" *ngIf="txnError">
      <i class="pe-7s-attention me-1"></i>{{ txnError }}
    </div>

    <!-- Empty -->
    <div class="text-center py-4 text-muted small" *ngIf="!isLoadingTxns && !txnError && transactions.length === 0">
      No transactions found for this member.
    </div>

    <!-- Transactions table -->
    <div class="table-responsive" *ngIf="!isLoadingTxns && transactions.length">
      <p class="text-muted small mb-2">{{ transactions.length }} transaction(s). Click <i class="pe-7s-look"></i> to view books.</p>
      <table class="table table-bordered align-middle mtr-table">
        <thead class="table-light">
          <tr>
            <th>Date</th>
            <th>Location</th>
            <th class="text-center">Issued</th>
            <th class="text-center">Returned</th>
            <th class="text-center">View</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let txn of transactions; let i = index" [class.mtr-row-tinted]="i % 2 !== 0">
            <td class="mtr-td-date">
              <div>{{ txn.timestamp | appDate }}</div>
              <div class="mtr-time">{{ txn.timestamp | date:'hh:mm a' }}</div>
            </td>
            <td>
              <span class="badge"
                    [class.bg-primary]="memberLocation === 'Door Delivery'"
                    [class.bg-success]="memberLocation === 'At Center'">
                {{ memberLocation }}
              </span>
            </td>
            <td class="text-center">
              <span class="mtr-count-badge mtr-issued" *ngIf="txn.issuedBooks?.length; else noIssued">
                {{ txn.issuedBooks.length }}
              </span>
              <ng-template #noIssued><span class="text-muted">—</span></ng-template>
            </td>
            <td class="text-center">
              <span class="mtr-count-badge mtr-returned" *ngIf="txn.receivedBooks?.length; else noReturned">
                {{ txn.receivedBooks.length }}
              </span>
              <ng-template #noReturned><span class="text-muted">—</span></ng-template>
            </td>
            <td class="text-center">
              <button type="button" class="btn btn-sm mtr-detail-btn"
                      (click)="openTxnDetail(txn)"
                      title="View books">
                <i class="pe-7s-look"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div><!-- /transactions view -->

</div>

<!-- ── Transaction Detail Modal ─────────────────────────────────────────────── -->
<div class="mtr-detail-overlay" *ngIf="selectedTxn" (click)="closeTxnDetail()">
  <div class="mtr-detail-modal" (click)="$event.stopPropagation()">

    <div class="mtr-detail-modal-header">
      <div>
        <div class="fw-bold" style="color:#1e1b4b;">
          <i class="pe-7s-date me-1 text-primary"></i>{{ selectedTxn.timestamp | appDate }}
          <span class="mtr-time ms-2">{{ selectedTxn.timestamp | date:'hh:mm a' }}</span>
        </div>
      </div>
      <button type="button" class="mtr-close-btn" (click)="closeTxnDetail()">
        <i class="pe-7s-close"></i>
      </button>
    </div>

    <div class="mtr-detail-modal-body">

      <div *ngIf="selectedTxn.remarks" class="mtr-remarks-row mb-3">
        <i class="pe-7s-comment mtr-remarks-icon"></i>
        <span>{{ selectedTxn.remarks }}</span>
      </div>

      <div class="mtr-detail-books">

        <div *ngIf="selectedTxn.issuedBooks?.length" class="mtr-detail-section">
          <div class="mtr-detail-section-title issued">
            <i class="pe-7s-upload me-1"></i>Issued ({{ selectedTxn.issuedBooks.length }})
          </div>
          <table class="table table-sm mtr-mini-table mb-0">
            <thead><tr><th>#</th><th>Book Name</th><th>Sr No.</th></tr></thead>
            <tbody>
              <tr *ngFor="let b of selectedTxn.issuedBooks; let i = index">
                <td>{{ i + 1 }}</td><td>{{ b.bookName }}</td><td>{{ b.bookSrNo }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="selectedTxn.receivedBooks?.length" class="mtr-detail-section">
          <div class="mtr-detail-section-title returned">
            <i class="pe-7s-download me-1"></i>Returned ({{ selectedTxn.receivedBooks.length }})
          </div>
          <table class="table table-sm mtr-mini-table mb-0">
            <thead><tr><th>#</th><th>Book Name</th><th>Sr No.</th></tr></thead>
            <tbody>
              <tr *ngFor="let b of selectedTxn.receivedBooks; let i = index">
                <td>{{ i + 1 }}</td><td>{{ b.bookName }}</td><td>{{ b.bookSrNo }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </div>
</div>
